"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const button_1 = __importStar(require("@app/routes/SpeechDevelopment/button"));
const smallHeader_1 = __importDefault(require("@components/smallHeader"));
const title_1 = __importDefault(require("@app/routes/SpeechDevelopment/title"));
const useCoins_1 = __importDefault(require("@hooks/useCoins"));
const useWindowWidrh_1 = __importDefault(require("@hooks/useWindowWidrh"));
const bg3_png_1 = __importDefault(require("../../assets/images/bg3.png"));
const audioPlayer_1 = require("@app/services/audioPlayer");
const audioPathNames_1 = require("@app/enums/audioPathNames");
const uiConfigs_1 = require("@app/constants/uiConfigs");
const loading_1 = __importDefault(require("@components/loading"));
const quantityGame_1 = __importDefault(require("@components/quantity/quantityGame"));
const uiConfigs_2 = require("@app/utils/uiConfigs");
const sendInfoReport_1 = require("@app/utils/sendInfoReport");
const generateInitialState = (length) => {
    return Array.from({ length }, (_, index) => ({
        isCorrect: false,
        index: index + 1,
        isChecked: false
    }));
};
const ContainerExercise = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: calc(100vw - 80px);
    height: 100%;
    max-width: 1760px;
    font-family: Phenomena;
    //margin-top: 50px;
    @media (max-width: 400px) {
        width: calc(100vw - 32px);
    }
    @media (max-height: 500px) {
        margin-top: 55px;
    }
    margin: 0 auto;//TODO:CHECK
    left: 0;
    right: 0;
`;
const ExerciseWrapper = styled_components_1.default.div `
    width: 100%;
    max-width: 100%;
    padding: 20px 35px;
    border-radius: 50px;
    border: 3px solid #fff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 20px;
    margin-bottom: 12px;
    justify-content: space-between;
    //height: calc(100vh - 200px); TODO
    background: url(${(props) => props.backgroundImage}) no-repeat center center;
    background-size: cover;
    margin-top: ${(props) => props.wihMargin ? "58px" : 0};
    @media (max-width: 400px) {
        border: 0;
        box-shadow: none;
        width: calc(100vw - 10px);
        margin-left: 5px;
        margin-right: 5px;
    }
    @media (max-height: 795px) {
        height: max-content;
    }
`;
const DropContainerWrapper = styled_components_1.default.div `
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    gap: 20px;
    align-items: self-start;
    justify-content: end;
    height: 100%;
    @media (max-width: 1200px) {
        justify-content: center;
    }
    @media(max-width:700px){
        flex-direction: column;
    }
`;
const Pagination = styled_components_1.default.div `
    display: flex;
    justify-content: center;
    gap: 12px;
    @media (max-width: 800px) {
        gap: 4px;
    }
    @media (max-width: 750px) {
        gap: 0;
    }
`;
const PaginationItem = styled_components_1.default.span `
    background: ${(props) => props.active ? props.active : "#AEBBD2CF"};
    width: ${props => props.dynamicWidth}vw; // Dynamic width calculation
    height: ${props => props.dynamicWidth / 2}vw; // Maintain aspect ratio
    border-radius: 50px;
    border: ${(props) => props.active ? "1px solid #fff" : 0};

    @media (max-width: 768px) {
        width: ${props => props.dynamicWidth * 1.5}vw; // Increase size on smaller screens
        height: ${props => (props.dynamicWidth * 1.5) / 2}vw;
    }

`;
const ImagesWrapper = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    max-width: 130px;
    gap: 20px;
    align-items: center;
    justify-content: center;
    @media (max-width: 700px) {
        //max-height: 60px;
        flex-direction: row;
        display: flex;
        max-width: 100%;
        max-height: 70px;
        margin-left: 15px;
        gap: 10px;
    }
    @media (max-height: 684px) {
        gap: 50px;
    }
`;
const Description = styled_components_1.default.div `
    font-size: 30px;
    font-weight: bold;
    color: white;
    text-align: center;
    @media (max-width: 850px) {
        font-size: 18px;
        padding: 4px 15px;
    }

    @media (max-width: 540px) {
        font-size: 18px;
        padding: 3px 10px;
        font-weight: 700;
    }
`;
const BubbleContainer = styled_components_1.default.div `
    position: relative;
    width: 100%;
    height: 100%;
    background-size: cover;
    display: flex;
    flex-direction: column;
`;
const BubbleRow = styled_components_1.default.div `
    position: relative;
    width: 100%;
    height: ${(props) => props.height || "100%"};
    background-size: cover;
    display: flex;
    flex-direction: row;
    gap: 9px;
    //gap: 26px;

    //margin-top: 70px;
    /* HTML: <div class="loader"></div> */

`;
const BubbleRowStart = styled_components_1.default.div `
    position: relative;
    width: 100%;
    height: ${(props) => props.height || "100%"};
    background-size: cover;
    display: flex;
    flex-direction: row;
    gap: 9px;
    //gap: 26px;

    //margin-top: 70px;
    /* HTML: <div class="loader"></div> */
    @media (max-width: 700px) {
        justify-content: space-between;
        margin-bottom: 45px;
    }
`;
const Bubble = styled_components_1.default.div `
    position: relative;
    width: 100%; //TODO:CHECK
    max-width: 120px;
    height: 120px; //TODO:CHECK
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 36px;
    font-weight: bold;
    color: white;
    background: ${(props) => props.color || '#3498db'};
    border-radius: 50%;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
    border: 3px solid white;
    transform:${(props) => `translateY(${props.y || 0})`};;

    @media (max-width: 1200px) {
        width: 95px;
        height: 95px;
        font-size: 30px;

    }

    @media (max-width: 880px) {
        width: 75px;
        height: 75px;

    }

    @media (max-width: 520px) {
        width: 55px;
        height: 55px;
        font-size: 16px;

    }
    /// small bubble
    &::before,
    &::after {
        content: '';
        position: absolute;
        width: 15px;
        height: 7px;
        background-color: rgba(255, 255, 255, 0.8);
        border-radius: 50%;
        transform: rotate(-30deg);
    }

    &::before {
        top: 15px;
        left: 31px;
        width: 8px;
        height: 5px;
    }

    &::after {
        top: 20px;
        left: 15px;
    }

    @media (max-width: 740px) {

        &::before {
            top: 10px;
            left: 18px;
        }

        &::after {
            top: 10px;
            left: 8px;
        }
    }

    @media (max-width: 740px) {

        &::before {
            top: 4px;
            left: 18px;
            width: 6px;
            height: 4px;
        }

        &::after {
            top: 6px;
            left: 8px;
            width: 10px;
            height: 5px;
        }
    }
}

`;
const StartFinishButton = styled_components_1.default.div `
  position: relative;
  width: 155px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  font-weight: bold;
  color: white;
  background-color: ${(props) => props.color || '#3498db'};
  border-radius: 25px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  border: 3px solid white;
  transform:${(props) => `translateY(${props.y || 0})`};;
   
    
    &::before,
    &::after {
        content: '';
        position: absolute;
        width: 15px;
        height: 7px;
        background-color: rgba(255, 255, 255, 0.8);
        border-radius: 50%;
        transform: rotate(-30deg);
    }

    &::before {
        top: 6px;
        left: 31px;
        width: 8px;
        height: 5px;
    }

    &::after {
        top: 6px;
        left: 15px;
    }
    @media (max-width: 520px) {
        width: 82px;
        height: 30px;
        font-size: 16px;
        &::before {
            top: 3px;
            left: 17px;
            width: 6px;
            height: 3px;
        }

        &::after {
            top: 6px;
            left: 7px;
            width: 10px;
            height: 5px;
        }
    }

`;
function sanitizeAndParse(data) {
    try {
        const sanitizedData = data
            .replace(/'/g, '"') // Replace single quotes with double quotes
            .replace(/\s+/g, ' '); // Remove excessive whitespace
        const parsedData = JSON.parse(sanitizedData);
        return parsedData;
    }
    catch (error) {
        console.error("Error parsing JSON:", error);
        return null;
    }
}
const calculateWidth = (numItems) => {
    if (numItems > 20)
        return 2;
    else if (numItems > 10)
        return 3;
    else
        return 4;
};
let infoRep = [];
const Test = ({ response, description }) => {
    const [recognizer, setRecognizer] = (0, react_1.useState)(null);
    const [isRecognizing, setIsRecognizing] = (0, react_1.useState)(false);
    // const [recognizedQueue, setRecognizedQueue] = useState<string[]>([]);
    const [phonemeList, setPhonemeList] = (0, react_1.useState)([]);
    // const [attempts, setAttempts] = useState<Record<number, number>>({});
    // const [data, setData] = useState<Record<string, any | string | boolean>[]>([]);
    // const [initialData, setInitialData] = useState<Record<string, any | string | boolean>[]>([]);
    const [title, setTitle] = (0, react_1.useState)('');
    const { coinCount, rubyCount, diamondCount, addCoin } = (0, useCoins_1.default)();
    const [exercisesId, setSetExerciseId] = (0, react_1.useState)([]);
    const [onlyWordsList, setOnlyWordsList] = (0, react_1.useState)([]);
    const [exercisesWords, setExercisesWords] = (0, react_1.useState)([]);
    const [groupedBubbles, setGroupedBubbles] = (0, react_1.useState)([]);
    const [checkButtons, setCheckButtons] = (0, react_1.useState)(generateInitialState(10));
    const [currentIndex, setCurrentIndex] = (0, react_1.useState)(0); // Индекс текущего слога
    // const [maxAttempts, setMaxAttempts] = useState(3); // Максимум попыток на каждый слог
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [bubblesCount, setBubblesCount] = (0, react_1.useState)(0);
    const windowWidth = (0, useWindowWidrh_1.default)();
    const handleAddCoin = () => {
        addCoin(3, 5);
    };
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d, _e, _f;
        const rootElement = document.getElementById("ezspeech-react-front");
        if (rootElement) {
            const id = rootElement.getAttribute("data-exercise-id");
            const words = rootElement.getAttribute("data-exercise-words");
            const title = rootElement.getAttribute("data-exercise-name");
            setTitle(title);
            const updatedWords = (_b = (_a = sanitizeAndParse(words)) === null || _a === void 0 ? void 0 : _a.exercise_full_word) === null || _b === void 0 ? void 0 : _b.map((item, idx) => (Object.assign(Object.assign({}, item), { text: item === null || item === void 0 ? void 0 : item.word, color: '#0794F9', id: idx + 1 })));
            // @ts-ignore
            setOnlyWordsList((_d = (_c = sanitizeAndParse(words)) === null || _c === void 0 ? void 0 : _c.list_words) === null || _d === void 0 ? void 0 : _d.map(item => item === null || item === void 0 ? void 0 : item.toLowerCase()));
            setCheckButtons(generateInitialState((_f = (_e = sanitizeAndParse(words)) === null || _e === void 0 ? void 0 : _e.list_words) === null || _f === void 0 ? void 0 : _f.length));
            const bubbleCount = windowWidth > 1570
                ? 10
                : windowWidth > 1420
                    ? 9
                    : windowWidth > 1300
                        ? 8
                        : windowWidth > 980
                            ? 7
                            : windowWidth > 420
                                ? 6
                                : 5;
            setBubblesCount(bubbleCount);
            const groups = [];
            for (let i = 0; i < updatedWords.length; i += bubbleCount) {
                groups.push(updatedWords.slice(i, i + bubbleCount));
            }
            setSetExerciseId(id);
            setExercisesWords(updatedWords);
            setGroupedBubbles(groups);
        }
    }, [windowWidth]);
    (0, react_1.useEffect)(() => {
        setIsLoading(true);
        const initRecognizer = () => __awaiter(void 0, void 0, void 0, function* () {
            const stream = yield window.navigator.mediaDevices.getUserMedia({
                audio: {
                    sampleRate: 16000,
                    sampleSize: 16,
                    channelCount: 1,
                },
            });
            // @ts-ignore
            const recognizerInstance = new window.RecognizerSyllablesChainBE(onlyWordsList, exercisesId);
            yield recognizerInstance.init(stream);
            setRecognizer(recognizerInstance);
            setIsLoading(false);
        });
        if (onlyWordsList.length) {
            initRecognizer();
        }
    }, [exercisesId, onlyWordsList]);
    const startRecognition = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsRecognizing(true);
            console.log('Recognizer started');
            // document.addEventListener('recognizeWordEvent', (e) => handleRecognizeWordEvent(e, filteredOptions));
            infoRep = [...infoRep, { rep_id: currentIndex, category_name: '', system_time: '', startTime: Date.now() }];
        }
        catch (error) {
            console.error('Error accessing microphone:', error);
            setIsRecognizing(false);
        }
    });
    const stopRecognition = () => {
        if (recognizer) {
            recognizer === null || recognizer === void 0 ? void 0 : recognizer.onStop();
            setIsRecognizing(false);
            setCheckButtons(uiConfigs_1.initialButtonState);
        }
    };
    const handleButtonClick = () => {
        if (!isLoading) {
            if (isRecognizing) {
                stopRecognition();
                // @ts-ignore
                window.stopExercise(true, true, exercisesId);
                // @ts-ignore
                (0, sendInfoReport_1.sendInfoReport)(infoRep, exercisesId, window.userId, checkButtons);
            }
            else {
                startRecognition();
            }
        }
    };
    const handleRecognition = (recognizedSyllable) => {
        var _a, _b;
        console.log('Handling recognition for:', recognizedSyllable);
        const currentSyllable = (_a = phonemeList[currentIndex]) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        const recognized = (_b = recognizedSyllable === null || recognizedSyllable === void 0 ? void 0 : recognizedSyllable[0]) === null || _b === void 0 ? void 0 : _b.toLowerCase();
        const isCorrect = currentSyllable === recognized;
        const flattenedBubbles = groupedBubbles.flat();
        const updatedBubbles = flattenedBubbles.map((bubble, index) => {
            if (index === currentIndex) {
                const attempts = (bubble.attempts || 0) + 1;
                if (attempts >= 3 && !isCorrect) {
                    audioPlayer_1.audioPlayer.stopAudio();
                    audioPlayer_1.audioPlayer.playAudio(audioPathNames_1.AudioPathNames.Incorrect);
                    setCheckButtons((prevButtons) => {
                        const indexToUpdate = prevButtons.findIndex(button => !button.isChecked);
                        if (indexToUpdate === -1) {
                            // @ts-ignore
                            window.stopExercise(true, true, exercisesId);
                            // @ts-ignore
                            (0, sendInfoReport_1.sendInfoReport)(infoRep, exercisesId, window.userId, checkButtons);
                            return prevButtons;
                        }
                        return prevButtons.map((button, idx) => {
                            if (idx === indexToUpdate) {
                                return Object.assign(Object.assign({}, button), { isChecked: true, isCorrect: false });
                            }
                            return button;
                        });
                    });
                    console.log('Max attempts reached. Moving to next bubble.');
                    setCurrentIndex((prev) => {
                        var _a;
                        const nextIndex = prev + 1;
                        console.log('first log', prev);
                        if (nextIndex >= (checkButtons === null || checkButtons === void 0 ? void 0 : checkButtons.length) - 1) {
                            // @ts-ignore
                            window.stopExercise(true, true, exercisesId);
                            // @ts-ignore
                            (0, sendInfoReport_1.sendInfoReport)(infoRep, exercisesId, window.userId, checkButtons);
                        }
                        else {
                            const newData = [...infoRep];
                            const timeOfRepetition = (Date.now() - ((_a = newData[index]) === null || _a === void 0 ? void 0 : _a.startTime)) / 1000;
                            newData[(newData === null || newData === void 0 ? void 0 : newData.length) - 1] = Object.assign(Object.assign({}, newData[(newData === null || newData === void 0 ? void 0 : newData.length) - 1]), { category_name: isCorrect ? uiConfigs_2.categoryIds[uiConfigs_2.categoriesName.correct] : uiConfigs_2.categoryIds[uiConfigs_2.categoriesName.incorrect], system_time: parseFloat(timeOfRepetition.toFixed(1)) });
                            infoRep = newData;
                        }
                        return nextIndex;
                    });
                    return Object.assign(Object.assign({}, bubble), { attempts, color: '#FF1431' });
                }
                if (isCorrect) {
                    handleAddCoin();
                    console.log('Correct! Moving to next bubble.');
                    setCheckButtons((prevButtons) => {
                        const indexToUpdate = prevButtons.findIndex(button => !button.isChecked);
                        if (indexToUpdate === -1) {
                            // @ts-ignore
                            window.stopExercise(true, true, exercisesId);
                            // @ts-ignore
                            (0, sendInfoReport_1.sendInfoReport)(infoRep, exercisesId, window.userId, checkButtons);
                            return prevButtons;
                        }
                        return prevButtons.map((button, idx) => {
                            if (idx === indexToUpdate) {
                                return Object.assign(Object.assign({}, button), { isChecked: true, isCorrect: true });
                            }
                            return button;
                        });
                    });
                    setCurrentIndex((prev) => {
                        var _a;
                        const nextIndex = prev + 1;
                        console.log('second log', prev);
                        if (nextIndex > (checkButtons === null || checkButtons === void 0 ? void 0 : checkButtons.length) - 1) {
                            // @ts-ignore
                            window.stopExercise(true, true, exercisesId);
                            // @ts-ignore
                            (0, sendInfoReport_1.sendInfoReport)(infoRep, exercisesId, window.userId, checkButtons);
                        }
                        else {
                            const newData = [...infoRep];
                            const timeOfRepetition = (Date.now() - ((_a = newData[index]) === null || _a === void 0 ? void 0 : _a.startTime)) / 1000;
                            newData[(newData === null || newData === void 0 ? void 0 : newData.length) - 1] = Object.assign(Object.assign({}, newData[(newData === null || newData === void 0 ? void 0 : newData.length) - 1]), { category_name: isCorrect ? uiConfigs_2.categoryIds[uiConfigs_2.categoriesName.correct] : uiConfigs_2.categoryIds[uiConfigs_2.categoriesName.incorrect], system_time: parseFloat(timeOfRepetition.toFixed(1)) });
                            infoRep = newData;
                            infoRep = [...infoRep, { rep_id: nextIndex + 1, category_name: '', system_time: '', startTime: Date.now() }];
                        }
                        return nextIndex;
                    });
                    return Object.assign(Object.assign({}, bubble), { attempts, color: 'linear-gradient(130deg, #6cff4f 13.21%, #13c21c 81.73%)' });
                }
                audioPlayer_1.audioPlayer.stopAudio();
                // audioPlayer.playAudio(AudioPathNames.Incorrect)
                audioPlayer_1.audioPlayer.playAudio('x', 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/Russian-error-328.mp3');
                return Object.assign(Object.assign({}, bubble), { attempts });
            }
            return bubble;
        });
        const regroupedBubbles = [];
        for (let i = 0; i < updatedBubbles.length; i += bubblesCount) {
            regroupedBubbles.push(updatedBubbles.slice(i, i + bubblesCount));
        }
        setGroupedBubbles(regroupedBubbles);
    };
    (0, react_1.useEffect)(() => {
        const handleRecognizeSyllEvent = (event) => {
            const recognizedSyllable = event.detail.syll;
            handleRecognition(recognizedSyllable);
        };
        document.addEventListener('recognizeSyllEvent', handleRecognizeSyllEvent);
        return () => {
            document.removeEventListener('recognizeSyllEvent', handleRecognizeSyllEvent);
        };
    }, [recognizer, phonemeList, groupedBubbles]);
    (0, react_1.useEffect)(() => {
        const handlePhonemeListEvent = (event) => {
            setPhonemeList(event.detail.syllables || []);
        };
        document.addEventListener('listOfSyllablesInPhoneme', handlePhonemeListEvent);
        return () => {
            document.removeEventListener('listOfSyllablesInPhoneme', handlePhonemeListEvent);
        };
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        windowWidth <= 1200 ? react_1.default.createElement(smallHeader_1.default, { exerciseName: title }) : react_1.default.createElement(react_1.default.Fragment, null),
        react_1.default.createElement(ContainerExercise, null,
            windowWidth <= 1200 ? react_1.default.createElement(react_1.default.Fragment, null) : react_1.default.createElement(title_1.default, { text: title, hasSmallText: true }),
            react_1.default.createElement(ExerciseWrapper, { backgroundImage: bg3_png_1.default },
                isLoading && !isRecognizing ? react_1.default.createElement(loading_1.default, { setIsLoading: setIsLoading, text: title, defaultDelay: 1200 }) : react_1.default.createElement(react_1.default.Fragment, null),
                react_1.default.createElement(Description, null, description || ''),
                react_1.default.createElement(DropContainerWrapper, null,
                    react_1.default.createElement(BubbleContainer, null,
                        react_1.default.createElement(BubbleRowStart, { height: "60px" },
                            react_1.default.createElement(StartFinishButton, { color: "#0794F9", style: { top: 10, left: 10 } }, "\u0421\u0442\u0430\u0440\u0442"),
                            windowWidth <= 700 ? react_1.default.createElement(quantityGame_1.default, { diamondCount: diamondCount, rubyCount: rubyCount, goldCoin: coinCount }) : react_1.default.createElement(react_1.default.Fragment, null)),
                        groupedBubbles.map((group, groupIndex) => (react_1.default.createElement(BubbleRow, { key: groupIndex, style: {
                                position: 'relative',
                                marginBottom: '50px', // Разделение групп
                            } }, group.map((item, index) => {
                            return (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(Bubble, { key: `${groupIndex}-${index}`, 
                                    // style={{ left: `${item.x}px`, top: `${item.y}px` }}
                                    color: item.color, y: `${index > 0 ? index > 1 ? index > 4 ? groupIndex === 0
                                        && index === (group === null || group === void 0 ? void 0 : group.length) - 1
                                        ? (index * 10) : (index * 10) - 30 : 50 - (index * 20) : 20 + (index * 20) : groupIndex === 1
                                        && index === 0 ? 60 : 20}%` },
                                    item.text,
                                    groupIndex === (groupedBubbles === null || groupedBubbles === void 0 ? void 0 : groupedBubbles.length) - 1
                                        && index === (group === null || group === void 0 ? void 0 : group.length) - 1
                                        &&
                                            react_1.default.createElement(StartFinishButton, { color: "#0794F9", style: { bottom: bubblesCount === index + 1 ? "-80px" : 10, position: "absolute", right: bubblesCount === index + 1 ? '-80px' : windowWidth > 520 ? "-170px" : "-93px" } }, "\u0424\u0438\u043D\u0438\u0448"))));
                        }))))),
                    windowWidth > 700 ? react_1.default.createElement(quantityGame_1.default, { diamondCount: diamondCount, rubyCount: rubyCount, goldCoin: coinCount }) : react_1.default.createElement(react_1.default.Fragment, null)),
                react_1.default.createElement(Pagination, null, checkButtons.map((item, index) => react_1.default.createElement(PaginationItem, { key: index, item: item, dynamicWidth: calculateWidth(checkButtons.length), active: item.isCorrect && item.isChecked ? "linear-gradient(130deg, #6cff4f 13.21%, #13c21c 81.73%)" : !item.isCorrect && item.isChecked ? "#FF1431" : null })))),
            react_1.default.createElement(button_1.ButtonContainerWrapper, null,
                react_1.default.createElement(button_1.default, { isShowShadow: true, isStarted: isRecognizing, label: `${!isRecognizing ? 'Старт' : 'Стоп'}`, onClick: handleButtonClick, isCheckButton: false })))));
};
exports.default = Test;
